import { createRouter, createWebHistory } from 'vue-router'

import HomeIndex from '~/components/Home/Index.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeIndex,
      props: true 
    },

  ]
})

export default router
